<template>
  <div class="h-dialogContainer h-track-tabPage">
    <div class="row"></div>
    <form id="addObserveForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.taskName')}}:</div>
          <ejs-textbox name="taskNameCheck" v-model="taskName"></ejs-textbox>
        </div>

        <div class="col-sm-6 h-col-inputBox" id='sliceIdShow' >
          <div class="h-inputLit">{{$t('Observe.sliceId')}}:</div>
          <ejs-textbox name="sliceIdCheck" v-model="sliceId"></ejs-textbox>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.startTime')}}:</div>
          <ejs-datetimepicker
            format="yyyy-MM-dd HH:mm:ss"
            v-model="startTime"
            :locale="locale"
            step="1"
            timeFormat="HH:mm:ss"
            :allowEdit="false"
            :enabled="true"
          ></ejs-datetimepicker>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.endTime')}}:</div>
          <ejs-datetimepicker
            format="yyyy-MM-dd HH:mm:ss"
            v-model="endTime"
            :locale="locale"
            step="1"
            timeFormat="HH:mm:ss"
            :allowEdit="false"
            :enabled="true"
          ></ejs-datetimepicker>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.reportLevel')}}:</div>
          <ejs-dropdownlist
            :dataSource="reportLevelList"
            v-model="reportLevel"
            name="reportLevelCheck"
            :fields="fieldsOfLevel"
            @change="changeForStatus"
          ></ejs-dropdownlist>
        </div>
      </div>

      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.allUserTag')}}:</div>
          <ejs-checkbox
            :label="$t('Observe.all')"
            ref="userTag"
            :checked="false"
            :change="setChecking"
          ></ejs-checkbox>
        </div>
      </div>

      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.userIdList')}}:</div>
          <ejs-textbox
            ref="userIdListRef"
            id="userIdListDisabled"
            :multiline="true"
            class="e-input e-input-group"
            :readonly="isReadOnly"
            v-model="userIdList"
            :placeholder="showPlaceholder"
            name="userIdListCheck"
          />
        </div>
      </div>

    </form>
  </div>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";
import mixin from "../../../mixin/mixin";

export default {
  name: "AddObserveTask",
  mixins: [mixin],
  components: {},
  data() {
    return {
      showPlaceholder:this.$t('Observe.userPlaceholder'), 
      isReadOnly: false,
      locale: localStorage.getItem("locale"),
      startTime: new Date(),
      endTime: new Date(new Date().getTime() + 24 * 60 * 60 * 1000).Format(
        "yyyy-MM-dd HH:mm:ss"
      ),
      taskName: "",
      sliceId: "",
      reportLevel: 1,
      userIdList: [],
      formObj: "",
      inputNames: [
        "taskNameCheck",
        "sliceIdCheck",
        "reportLevelCheck",
        "userIdListCheck",
      ],
      allUserTag: 0,
      currentNeData: {},
      fieldsOfLevel: {
        text: "text",
        value: "value"
      },
      reportLevelList: [
        { text: this.$t("Observe.reportError"), value: 1 },
        { text: this.$t("Observe.reportWarning"), value: 2 },
        { text: this.$t("Observe.reportInfo"), value: 3 }
      ],
      rules: {
        taskNameCheck: {
          required: true,
          regex: "taskNameCheck",
          maxLength: 20
        },
        sliceIdCheck: {
          required: true,
          regex: "integer",
          min: 0,
          max: 255
        },
        reportLevelCheck: {
          required: true
        },
        userIdListCheck: {
          required: true,
          regex: "userIdListCheck"
        },
      },

    };
  },
  methods: {
    changeForStatus(msg) {
      this.reportLevel = msg.value;
    },
    clear() {
      this.taskName = "";
      this.sliceId = "";
      this.reportLevel = 1;
      this.userIdList = [];
      this.allUserTag = 0;
      this.startTime = new Date();
      this.endTime = new Date(
        new Date().getTime() + 24 * 60 * 60 * 1000
      ).Format("yyyy-MM-dd HH:mm:ss");
      this.checkRole();
    },
    setChecking() {
      let userTag = this.$refs.userTag.ej2Instances.checked;
      if (userTag) {
        //数字1代表全用户，0代表不是全用户
        this.allUserTag = 1;
      } else {
        this.allUserTag = 0;
      }
      this.isReadOnly = userTag;
      if (this.isReadOnly) {
        //根据任务UNM-555修改：全部后不应提示该项不能为空
        this.formObj.addRules("userIdListCheck", {
          required: [true, ``],
        });  
        this.formObj.validate();
        //1是true 是禁用 全选  0是未勾选，非禁用
        this.formObj.removeRules("userIdListCheck");
        this.showPlaceholder="";
      } else {
        if(this.currentNeData.typeCode==43||this.currentNeData.typeCode==44||this.currentNeData.typeCode==45||this.currentNeData.typeCode==46||this.currentNeData.typeCode==47||this.currentNeData.typeCode==48){
          this.formObj.addRules("userIdListCheck", {
          required: [true, `${this.$t("Track.fieldIsRequired")}`],
          regex: ['^(((sip:[+]?[1-9]{1}[0-9]{5,14}\\@[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?)|(tel:[+]{0,1}[1-9]{1}[0-9]{5,14})|([0-9]{1}[0-9]{5,14}\\@[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?))+,){0,9}((sip:[+]?[1-9]{1}[0-9]{5,14}\\@[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?)|(tel:[+]{0,1}[1-9]{1}[0-9]{5,14})|([0-9]{1}[0-9]{5,14}\\@[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?))$', this.$t("Observe.invalidFormat")]
          });  
          this.showPlaceholder=this.$t('Observe.userPlaceholderHss');     
        }else{
          this.formObj.addRules("userIdListCheck", {
          required: [true, `${this.$t("Track.fieldIsRequired")}`],
          regex: ["^(\\d+,){0,9}\\d+$", this.$t("Observe.invalidFormat")]
          });  
          this.showPlaceholder=this.$t('Observe.userPlaceholder');     
        }

      }
    },
    tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    loadNeForm(currentNe) {
      this.$nextTick(() => {
      try {
        this.currentNeData = currentNe;
        if(this.currentNeData.typeCode==43||this.currentNeData.typeCode==44||this.currentNeData.typeCode==45||this.currentNeData.typeCode==46||this.currentNeData.typeCode==47||this.currentNeData.typeCode==48){
         this.showPlaceholder=this.$t('Observe.userPlaceholderHss');          
          this.rules.userIdListCheck.regex='userIdListCheckHss'
          document.getElementById("sliceIdShow").style.display = "none"; //隐藏切片标识
          this.sliceId=0;
        }
        else{
          this.showPlaceholder=this.$t('Observe.userPlaceholder');          
          this.rules.userIdListCheck.regex='userIdListCheck'
          document.getElementById("sliceIdShow").style.display = "block"; //显示切片标识
        }
        this.bindValidate();
      } catch (e) {
        console.log(e);
      }});
    },
    getFormData() {
      if (!this.validate()) {
        return false;
      }
      if(1===this.allUserTag){
        this.userIdList=[];
      }
      else if(0===this.allUserTag){
        const userIdLists = this.userIdList.split(',');
        var nary = userIdLists.sort();
        for (var i = 0; i < nary.length; i++) {
          if (nary[i] == nary[i + 1]) {
            EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Observe.duplicateContent')}`});
            return false;
          }
        }
     }
      return {
        neId: this.currentNeData.id,
        taskName: this.taskName,
        sliceId: this.sliceId,
        reportLevel: this.reportLevel,
        userIdList: this.userIdList,
        allUserTag: this.allUserTag,
        startTime: this.startTime.getTime(),
        endTime: this.endTime.getTime()
      };
    },
    bindValidate() {
      this.formObj = this.validateForm(
        "addObserveForm",
        this.inputNames,
        this.rules
      );
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    checkRole() {
      let role = false;
      this.$axios.get("/lte/ems/auth/findSystemRole").then(response => {
        if (
          response &&
          response.status === 200 &&
          response.data !== undefined
        ) {
          role = response.data;
        }
        if (role) {
          this.reportLevelList = [
            { text: this.$t("Observe.reportError"), value: 1 },
            { text: this.$t("Observe.reportWarning"), value: 2 },
            { text: this.$t("Observe.reportInfo"), value: 3 }
          ];
        } else {
          this.reportLevelList = [
            {
              text: this.$t("Observe.reportError"),
              value: 1
            }
          ];
        }
      });
    }
  },
  mounted() {
    // this.bindValidate();
    this.checkRole();
  },
};
</script>
